import { useIntl } from "react-intl";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export const StepIndicator = ({
  currentStep,
  totalSteps,
}: StepIndicatorProps) => {
  const intl = useIntl();

  return (
    <div
      className="flex items-center gap-1"
      role="progressbar"
      aria-valuenow={currentStep}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-label={intl.formatMessage(
        {
          id: "auth.register.stepIndicator",
          defaultMessage: "Step {current} of {total}",
        },
        { current: currentStep, total: totalSteps }
      )}
    >
      {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
        <div
          key={step}
          className={`h-1.5 rounded-full transition-colors ${
            step <= currentStep ? "bg-blue-500" : "bg-gray-200 dark:bg-gray-700"
          } ${step === currentStep ? "w-4" : "w-1.5"}`}
        />
      ))}
    </div>
  );
};
